export const restrictedTimingKeys = ['ssr'];

export const clsWaitTimeMs: number = 7500;
